import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import get from "lodash/get"
import { urls } from "utils-lib/builds"
import {
  GET_CANCEL_SERVICE_SERVLET_FULFILLED,
  GET_CANCEL_SERVICE_SERVLET_PENDING,
  GET_CANCEL_SERVICE_SERVLET_FAILED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: GET_CANCEL_SERVICE_SERVLET_PENDING,
})

export const failedAC = (data) => ({
  type: GET_CANCEL_SERVICE_SERVLET_FAILED,
  payload: data,
})

export const fulfilledAC = (type, data) => ({
  type,
  payload: data,
})

export const getCancelServiceServlet = () => (dispatch, getState) => {
  const { siteLanguage } = getState()
  const locale = encodeURI(siteLanguage?.language || ``)

  const api = `AEM_CANCEL_SERVICE`
  const template = URITemplate(urls.url[api])

  const exceptionURL = template.expand({
    locale,
  })
  const url = exceptionURL
  const config = {
    url,
    method: `get`,
  }

  dispatch(pendingAC(locale))
  // eslint-disable-next-line consistent-return
  return axios(config)
    .then((response) => {
      const data = get(response, `data`, {})

      dispatch(fulfilledAC(GET_CANCEL_SERVICE_SERVLET_FULFILLED, data))
      return response
    })
    .catch((error) => {
      dispatch(failedAC(error?.response?.status))
      return error
    })
}
